import { useMutation } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../CommonUtils/httpBodyOptions';

const sendContact = (message: string) => {
  return authFetch('/Adviser/UserFeedback/Save', {
    method: 'POST',
    ...httpBodyOptions({ origin: JSON.stringify(ADV.util.Router.status()), message }),
  });
};

export const useContactMutation = () => useMutation(sendContact);
